import { useQuery } from "@tanstack/react-query";
import { getCurrentUser } from "../../services/apiAuth";

/**
 * Loads and exposes the current authenticated user.
 *
 * @returns {{ user: object | undefined, isLoading: boolean, isAuthenticated: boolean }} User query state.
 */
export function useUser() {
    const { isLoading, data: user } = useQuery({
        queryKey: ["user"],
        queryFn: getCurrentUser,
    });
    return { user, isLoading, isAuthenticated: user?.role === "authenticated" };
}
